import { render, staticRenderFns } from "./UnitTest.vue?vue&type=template&id=2736cd26"
import script from "./UnitTest.vue?vue&type=script&lang=js"
export * from "./UnitTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports